<div class="uls ul-chip" [ngClass]="additionalClasses()">
  @if (showDot()) {
    <span class="dot" [ngClass]="additionalClasses()"></span>
  }
  <ng-content></ng-content>
</div>
